import React from "react";


export const ProjectDescription = (props) => {

    const {project} = props;

    return (
        <>
            <h2>Description du projet</h2>
            <p className="project-item__description">{project.notes || <em>Aucune description</em>}</p>
        </>
    )

}